
$(document).ready(function(){

$('.lazy').slick({
  lazyLoad: 'ondemand',
  slidesToShow: 3,
  slidesToScroll: 1,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  $('.responsive').slick({
 
  infinite: false,
  speed: 500,
    fade: true,
  slidesToShow: 1,
  slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="fa fa-angle-left" ></i> Back </button>',
    nextArrow: '<button class="slide-arrow next-arrow">More <i class="fa fa-angle-right" ></i></button>',  
  responsive: [
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  });